import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-396948ed"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "catalog" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<h2 data-v-396948ed>Каталог</h2><div class=\"catalog-items\" data-v-396948ed><div class=\"item\" data-v-396948ed><div class=\"item__background\" data-v-396948ed></div><div class=\"item__wrapper\" data-v-396948ed><div class=\"item__info\" data-v-396948ed><h3 class=\"item__info-title\" data-v-396948ed></h3><h6 class=\"item__info-category uppercase\" data-v-396948ed></h6></div></div></div><div class=\"item\" data-v-396948ed><div class=\"item__background\" data-v-396948ed></div><div class=\"item__wrapper\" data-v-396948ed><div class=\"item__info\" data-v-396948ed><h3 class=\"item__info-title\" data-v-396948ed></h3><h6 class=\"item__info-category uppercase\" data-v-396948ed></h6></div></div></div></div>", 2)
const _hoisted_4 = [
  _hoisted_2
]


export default /*#__PURE__*/_defineComponent({
  __name: 'HomeCatalogLoader',
  setup(__props) {

const items = [1, 2]

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_4))
}
}

})